// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICommunicationDtoDestination } from './ICommunicationDtoDestination';
import {
    ICommunicationDtoDestinationFromJSON,
    ICommunicationDtoDestinationFromJSONTyped,
    ICommunicationDtoDestinationToJSON,
    ICommunicationDtoDestinationToJSONTyped,
} from './ICommunicationDtoDestination';
import type { ICommunicationDtoView } from './ICommunicationDtoView';
import {
    ICommunicationDtoViewFromJSON,
    ICommunicationDtoViewFromJSONTyped,
    ICommunicationDtoViewToJSON,
    ICommunicationDtoViewToJSONTyped,
} from './ICommunicationDtoView';
import type { ICommunicationStatusDto } from './ICommunicationStatusDto';
import {
    ICommunicationStatusDtoFromJSON,
    ICommunicationStatusDtoFromJSONTyped,
    ICommunicationStatusDtoToJSON,
    ICommunicationStatusDtoToJSONTyped,
} from './ICommunicationStatusDto';

/**
 * 
 * @export
 * @interface ICommunicationDto
 */
export interface ICommunicationDto {
    /**
     * 
     * @type {number}
     * @memberof ICommunicationDto
     */
    id?: number;
    /**
     * 
     * @type {Date}
     * @memberof ICommunicationDto
     */
    datetime?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICommunicationDto
     */
    subject?: string;
    /**
     * 
     * @type {ICommunicationDtoDestination}
     * @memberof ICommunicationDto
     */
    destination?: ICommunicationDtoDestination;
    /**
     * 
     * @type {string}
     * @memberof ICommunicationDto
     */
    communication_type?: ICommunicationDtoCommunicationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ICommunicationDto
     */
    notification_status?: ICommunicationDtoNotificationStatusEnum;
    /**
     * 
     * @type {ICommunicationDtoView}
     * @memberof ICommunicationDto
     */
    view?: ICommunicationDtoView;
    /**
     * 
     * @type {boolean}
     * @memberof ICommunicationDto
     */
    is_resendable?: boolean;
    /**
     * 
     * @type {Array<ICommunicationStatusDto>}
     * @memberof ICommunicationDto
     */
    communication_statuses?: Array<ICommunicationStatusDto>;
}

/**
* @export
* @enum {string}
*/
export enum ICommunicationDtoCommunicationTypeEnum {
    EMAIL = 'EMAIL',
    LETTER = 'LETTER',
    SMS = 'SMS'
}
/**
* @export
* @enum {string}
*/
export enum ICommunicationDtoNotificationStatusEnum {
    NOT_SENT = 'NOT_SENT',
    SENT = 'SENT',
    CANCELLED = 'CANCELLED',
    ARCHIVED = 'ARCHIVED',
    READ = 'READ',
    RESENT = 'RESENT',
    SENDING = 'SENDING',
    BOUNCED = 'BOUNCED',
    DELIVERED = 'DELIVERED',
    OPENED = 'OPENED',
    REPORTED_AS_SPAM = 'REPORTED_AS_SPAM',
    UNSUBSCRIBED = 'UNSUBSCRIBED',
    RETURNED = 'RETURNED',
    PENDING_ADDRESS = 'PENDING_ADDRESS'
}


/**
 * Check if a given object implements the ICommunicationDto interface.
 */
export function instanceOfICommunicationDto(value: object): value is ICommunicationDto {
    return true;
}

export function ICommunicationDtoFromJSON(json: any): ICommunicationDto {
    return ICommunicationDtoFromJSONTyped(json, false);
}

export function ICommunicationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICommunicationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'datetime': json['datetime'] == null ? undefined : (new Date(json['datetime'])),
        'subject': json['subject'] == null ? undefined : json['subject'],
        'destination': json['destination'] == null ? undefined : ICommunicationDtoDestinationFromJSON(json['destination']),
        'communication_type': json['communication_type'] == null ? undefined : json['communication_type'],
        'notification_status': json['notification_status'] == null ? undefined : json['notification_status'],
        'view': json['view'] == null ? undefined : ICommunicationDtoViewFromJSON(json['view']),
        'is_resendable': json['is_resendable'] == null ? undefined : json['is_resendable'],
        'communication_statuses': json['communication_statuses'] == null ? undefined : ((json['communication_statuses'] as Array<any>).map(ICommunicationStatusDtoFromJSON)),
    };
}

export function ICommunicationDtoToJSON(json: any): ICommunicationDto {
    return ICommunicationDtoToJSONTyped(json, false);
}

export function ICommunicationDtoToJSONTyped(value?: ICommunicationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'datetime': value['datetime'] == null ? undefined : ((value['datetime']).toISOString()),
        'subject': value['subject'],
        'destination': ICommunicationDtoDestinationToJSON(value['destination']),
        'communication_type': value['communication_type'],
        'notification_status': value['notification_status'],
        'view': ICommunicationDtoViewToJSON(value['view']),
        'is_resendable': value['is_resendable'],
        'communication_statuses': value['communication_statuses'] == null ? undefined : ((value['communication_statuses'] as Array<any>).map(ICommunicationStatusDtoToJSON)),
    };
}

